import { Link } from "react-router-dom";
import { usePage } from "@/settings";

export function RedDot({ className = "w-2.5 h-2.5" }) {
  return (
    <span
      className={`inline-block rounded-full bg-brand shadow-[0_0_10px_rgba(229,56,39,0.5)] ${className}`}
    />
  );
}

export default function Logo({ dark = false, small = false }) {
  const g = usePage("global");
  const src = dark
    ? g.logo_white_url || "/iksha-logo-white.png"
    : g.logo_url || "/iksha-logo.png";
  return (
    <Link to="/" data-testid="logo-link" className="group inline-flex items-center select-none">
      <img
        src={src}
        alt="IKSHA — Art + Architecture"
        className={`${small ? "h-14" : "h-16"} w-auto transition-transform duration-500 group-hover:rotate-[-1.5deg] group-hover:scale-[1.03]`}
      />
    </Link>
  );
}
